import { useState, useRef, useEffect } from 'react'
import { createPortal } from 'react-dom'

// Market header ka hover tooltip (b-tooltip top placement) — superover2 se same.
function HeaderTooltip({ text, rect }) {
  const ref = (el) => {
    if (!el) return
    const w = el.offsetWidth
    const h = el.offsetHeight
    const x = Math.round(rect.left + window.scrollX + rect.width / 2 - w / 2)
    const y = Math.round(rect.top + window.scrollY - h)
    el.style.transform = `translate3d(${x}px, ${y}px, 0px)`
    const ar = el.querySelector('.arrow')
    if (ar) ar.style.left = `${Math.round(w / 2 - ar.offsetWidth / 2)}px`
  }
  return createPortal(
    <div
      id="__bv_tooltip_2048__"
      role="tooltip"
      tabIndex="-1"
      ref={ref}
      className="tooltip b-tooltip bs-tooltip-top show"
      x-placement="top"
      style={{ position: 'absolute', willChange: 'transform', top: '0px', left: '0px' }}
    >
      <div className="arrow"></div>
      <div className="tooltip-inner">{text}</div>
    </div>,
    document.body,
  )
}

// Accordion header — click pe nation-name pe `collapsed` (arrow up/down flip) +
// aria-expanded toggle; title hover pe b-tooltip. `right` = header ke right side
// buttons (Bet Lock / User Book). Pattern superover2 (SuperOverMarkets) se.
export function MarketHeader({ title, marketId, arrow, open, onToggle, right }) {
  const [tipRect, setTipRect] = useState(null)
  const tipAttrs = tipRect
    ? { title: '', 'data-original-title': title, 'aria-describedby': '__bv_tooltip_2048__' }
    : { title }
  return (
    <div className="bet-table-header">
      <div
        data-toggle="collapse"
        data-target={`#${marketId}`}
        aria-expanded={open ? 'true' : 'false'}
        className={`nation-name${open ? '' : ' collapsed'}`}
        onClick={onToggle}
      >
        <span
          {...tipAttrs}
          onMouseEnter={(e) => setTipRect(e.currentTarget.getBoundingClientRect())}
          onMouseLeave={() => setTipRect(null)}
        >
          <a href="javascript:void(0)" title="">
            <img src={arrow} className="mr-1" alt="" />
          </a>
          {'\n                    ' + title + '\n                '}
        </span>
      </div>
      {right && (
        <>
          {' '}
          <div className="float-right">{right}</div>
        </>
      )}
      {tipRect && <HeaderTooltip text={title} rect={tipRect} />}
    </div>
  )
}

// Bootstrap collapse animation replica — .collapsing (height transition .35s,
// app.css me) se show/hide, end pe collapse / collapse show. superover2 se same.
export function CollapseBody({ id, dataTitle, open, className = '', children }) {
  const ref = useRef(null)
  const first = useRef(true)
  const [cls, setCls] = useState(open ? 'collapse show' : 'collapse')
  const [style, setStyle] = useState(undefined)

  useEffect(() => {
    if (first.current) {
      first.current = false
      return
    }
    const el = ref.current
    if (!el) return
    let raf1
    let raf2
    if (open) {
      setCls('collapsing')
      setStyle({ height: '0px' })
      raf1 = requestAnimationFrame(() => {
        raf2 = requestAnimationFrame(() => setStyle({ height: `${el.scrollHeight}px` }))
      })
    } else {
      setStyle({ height: `${el.scrollHeight}px` })
      raf1 = requestAnimationFrame(() => {
        setCls('collapsing')
        raf2 = requestAnimationFrame(() => setStyle({ height: '0px' }))
      })
    }
    const t = setTimeout(() => {
      setCls(open ? 'collapse show' : 'collapse')
      setStyle(undefined)
    }, 350)
    return () => {
      cancelAnimationFrame(raf1)
      cancelAnimationFrame(raf2)
      clearTimeout(t)
    }
  }, [open])

  return (
    <div id={id} data-title={dataTitle} ref={ref} className={`bet-table-body ${className}${cls}`.trim()} style={style}>
      {children}
    </div>
  )
}
